import { render } from "./LeadsByCompanyPage.vue?vue&type=template&id=9024ad5a&ts=true"
import script from "./LeadsByCompanyPage.vue?vue&type=script&lang=ts"
export * from "./LeadsByCompanyPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__